import { observer } from 'mobx-react-lite';
import WidgetCalculatorForm from '../widget-calculator-form.component';
import { isFeatureRequired } from '../../../../utils/client/client.utils';
import { useStore } from '../../../../stores/store';

interface Props {
  isDomestic?: boolean;
}

const CalculatorIframeRouteWrapper = ({ isDomestic }: Props) => {
  const {
    localizationsStore: { selectedCountry },
  } = useStore();

  const props = isDomestic
    ? {
        isDomestic: true,
        useZipSearchForDeparture: true,
        useZipSearchForDestination: true,
      }
    : {
        isDomestic: false,
        useZipSearchForDeparture: isFeatureRequired(
          'calculatorUseZipDepartureSearch',
          selectedCountry?.country_code
        ),
        useZipSearchForDestination: isFeatureRequired(
          'calculatorUseZipDestinationSearch',
          selectedCountry?.country_code
        ),
      };

  return (
    <WidgetCalculatorForm
      isFrameMode
      {...props}
    />
  );
};

export default observer(CalculatorIframeRouteWrapper);
